module.exports = __webpack_public_path__ + "static/media/logo-instagram.009ceca6.png";